import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const CreateIndustryPage = () => (
  <TitleEntityForm
    create={apiRequests.portfolio.createIndustry}
    backTo="/portfolio/industries"
    placeholder="Например, Финтех"
    createdText="Индустрия создана"
  />
);

export default CreateIndustryPage;
